import { Log } from "../../util/Log";
var log = Log.log;
export class Alt1GLSession {
    constructor(alt1) {
        this.alt1 = alt1;
    }
    refreshSession() {
        if (!this.alt1.featureGL() || !this.alt1.raw.permissionGLApi) {
            return;
        }
        const session = this.alt1.raw.getGlSession();
        session.setCheckGlErrors(true);
        session.on("close", () => {
            log().log("Alt1GLSession crashed, refreshing...", "Alt1GL");
            this.refreshSession();
        });
        this.session = session;
    }
    get() {
        if (!this.session)
            this.refreshSession();
        return this.session;
    }
    forceClose() {
        this.session?.close();
        this.session = undefined;
    }
}
